import { render } from "./etDesignIndex.vue?vue&type=template&id=06115640"
import script from "./etDesignIndex.vue?vue&type=script&lang=js"
export * from "./etDesignIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__